import React from "react";

const modal = {
    position: "fixed",
    zIndex: 1,
    left: 0,
    top: 0,
    width: "100vw",
    height: "100vh",
    overflow: "auto",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
};

const modalContent = {
    display: "flex",
    alignItems: "center",
    height: "100%",
    margin: "auto",
};

export const Modal = ({ onOpen, children }) => {
    return <div onClick={onOpen}> {children}</div>;
};

export const ModalContent = ({ children }) => {
    return (
        <div style={modal} className="d-flex justify-content-center">
            <div style={modalContent}>{children}</div>
        </div>
    );
};
